import { ClerkProvider as ClerkProviderBase } from "@clerk/react";
import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { isInAppBrowser } from "@/lib/browser";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const HIDE_SOCIAL_APPEARANCE = {
  elements: {
    socialButtonsRoot: { display: "none" },
    dividerRow: { display: "none" },
  },
} as const;

interface ClerkProviderProps {
  children: ReactNode;
}

export function ClerkProvider({ children }: ClerkProviderProps) {
  const navigate = useNavigate();

  return (
    <ClerkProviderBase
      publishableKey={PUBLISHABLE_KEY}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      appearance={isInAppBrowser() ? HIDE_SOCIAL_APPEARANCE : undefined}
    >
      {children}
    </ClerkProviderBase>
  );
}
